import { getKeyLang } from '../helpers'
import { useBookingFormStore } from '../providers/BookingFormStoreProvider'
import { IRoomType } from '../store/data'
import { GUEST_PARAM, ROOM_TYPE_PARAM, useQueryParams } from './useQueryParams'

export const useRoomTypeAccordion = () => {
  const language = useBookingFormStore((state) => state.language)
  const changeRoomType = useBookingFormStore((state) => state.changeRoomType)
  const changeGuest = useBookingFormStore((state) => state.changeGuest)
  const guest = useBookingFormStore((state) => state.guest)

  const { addQueryParameter, removeQueryParameter, routerQueryParams } = useQueryParams()

  const updateRouteQuery = async (value: IRoomType | null) => {
    const roomTypeName = value?.category[getKeyLang(language)]

    if (roomTypeName) {
      await addQueryParameter(ROOM_TYPE_PARAM, roomTypeName)

      // if no guests were selected and room type has beds count, set guests count to beds count
      if (
        (!guest || typeof routerQueryParams?.guest === 'undefined' || routerQueryParams.guest === null) &&
        value?.beds
      ) {
        await addQueryParameter(GUEST_PARAM, `${value.beds}`)
        changeGuest(value.beds)
      }
    } else {
      await removeQueryParameter(ROOM_TYPE_PARAM)
    }
  }

  const validateRoomType = async (value: IRoomType | null) => {
    await updateRouteQuery(value)
  }

  const onChangeRoomType = async (value: IRoomType | null) => {
    changeRoomType(value)
    await validateRoomType(value)
  }

  const onInitRoomTypeValidation = async (value: IRoomType | null) => {
    await validateRoomType(value)
  }

  return {
    onChangeRoomType,
    onInitRoomTypeValidation,
  }
}
